import cn from 'classnames';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import addOPPlusSubscriptionAndRedirectToCartOperation from 'store/app/operation/addOPPlusSubscriptionAndRedirectToCartOperation';
import getOpPlusV3Info from 'store/dashboard/selector/getOpPlusV3Info';
import usePlusMembershipStatus from 'components/Plus/hooks/usePlusMembershipStatus';
import styles from './PlusStatusBanner.module.scss';

const PlusStatusBanner = () => {
  const subscriptonData = useSelector(getOpPlusV3Info);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    isCancelled: isMembershipCancelled,
    isCancelledBeforeRenewal: isMembershipCancelledBeforeRenewal,
    isMembershipWithdrawn,
    legacyExpiringSoon,
    legacyExpirationDays,
    isFailedPaymentPausedFirst30Days,
  } = usePlusMembershipStatus();

  const addOPPlus = () => {
    dispatch(addOPPlusSubscriptionAndRedirectToCartOperation());
  };

  const icon = isMembershipCancelledBeforeRenewal || legacyExpiringSoon ? 'warning' : 'error';

  const showRepurchaseButton =
    isMembershipCancelled ||
    isMembershipCancelledBeforeRenewal ||
    isFailedPaymentPausedFirst30Days ||
    isMembershipWithdrawn;

  return (
    <div className={cn(styles.container, styles[icon])}>
      <OpIcon icon={icon} size="small" className={styles[`icon-${icon}`]} />
      <OpText variant="body-special-large-regular">
        {isMembershipCancelled &&
          t('txt_plus_membership_cancelled', { date: subscriptonData?.subscriptionInfo.endDateFormatted })}
        {isMembershipWithdrawn &&
          t('txt_plus_membership_ended_on', { date: subscriptonData?.subscriptionInfo.cancelDateFormatted })}
        {isMembershipCancelledBeforeRenewal &&
          t('txt_plus_membership_cancelled_before_renewal', {
            date: subscriptonData?.subscriptionInfo.endDateFormatted,
          })}
        {legacyExpiringSoon && (
          <Trans
            t={t}
            i18nKey="txt_plus_membership_ending_in"
            values={{ date: legacyExpirationDays }}
            components={{ u: <u />, b: <b /> }}
          />
        )}

        {isFailedPaymentPausedFirst30Days && t('txt_plus_membership_payment_failed')}

        {showRepurchaseButton && (
          <span className={styles.repurchase} onClick={addOPPlus}>
            {' '}
            {t('txt_plus_membership_repurchase')}.
          </span>
        )}
      </OpText>
    </div>
  );
};

export default PlusStatusBanner;
